//价格过滤器
export default (filterPrice) => {
  return parseFloat(filterPrice).toFixed(2)   //此文件用来过滤价格 （使小数保留两位）
}



// WEBPACK FOOTER //
// ./src/filters/filterPrice.js